import type {FetchContext} from "ofetch";

export default defineNuxtPlugin(() => {
  const userAuth = useCookie<BearerToken | null>('auth')
  const {errorState} = useApp();
  const user = useState<User>('user')

  const $customFetch = $fetch.create({
    headers: {
      Accept: 'application/json',
      ContentType: 'application/json'
    },
    // @ts-ignore
    async onResponseError(context: FetchContext) {
      // @ts-ignore
      const showDialogError = context.options?.showDialogError !== false;

      if (context.response?.status === 401) {
        $customFetch('/api/logout', {
          method: 'post',
        }).finally(() => {
          userAuth.value = null;
          window.location.replace("/login")
        })
      }
      if (context.response?.status === 403
        && user.value && user.value.must_change_password) {
        navigateTo('change-password')
      }

      if (showDialogError) {
        errorState.value.dialog = true;
      }

      if (context.response?.status) {
        errorState.value.statusCode = context.response?.status;
      }

      if (context.response?._data.message) {
        errorState.value.message = context.response._data.message
      }

      return context
    }
  })

  return {
    provide: {
      customFetch: $customFetch
    }
  }
})
